<template>
  <div style="width: 100%; padding-top: 10px;height: 80vh;overflow: hidden">
    <swiper
      class="swiper-container">
      <swiper-slide class="swiper-slide">
        <div class="swiper-slide-container">
          <img style="width: 100%;height: auto;margin-bottom: 20px" src="//haiba-static.oss-cn-guangzhou.aliyuncs.com/lazyloadimg.png">
          <van-skeleton title :row="4" />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import VanSkeleton from 'vant/lib/skeleton'
import 'vant/lib/skeleton/style'

export default {
  name: "LoadingView",
  components: {
    Swiper,
    SwiperSlide,
    VanSkeleton
  },
}
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  box-sizing: border-box;
  text-align: center;
  padding: 0 0.4rem;
}
.swiper-slide .swiper-slide-container{
  box-sizing: border-box;
  width:100%;
  border-radius:7px;
  height: 90%;
  box-shadow: 0 0.666667vw 3.066667vw 1.466667vw rgb(0 0 0 / 13%);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  overflow: hidden;
}

</style>